import { jsx } from 'react/jsx-runtime.js';
import Popup from '@jetbrains/ring-ui/dist/popup/popup.js';
import FocusLock from 'react-focus-lock';
import styles from './MoreActionPopup.module.css.js';

function MoreActionPopup(props) {
  var children = props.children,
    opened = props.opened,
    onClose = props.onClose;
  return jsx(Popup, {
    hidden: !opened,
    onEscPress: onClose,
    onOutsideClick: onClose,
    className: styles.popup,
    children: jsx(FocusLock, {
      returnFocus: true,
      children: children
    })
  });
}

export { MoreActionPopup };
